module.exports = __webpack_public_path__ + "static/media/chickenShed.e73324fd.jpg";